export default {
  1: 'Autism Spectrum Disorder',
  2: 'Hearing Impairment',
  3: 'Mental Health Condition',
  4: 'Physical Disability',
  5: 'Progressive Chronic Condition',
  6: 'Vision Impairment',
}
